export default  {
  // 保存
  save: 'save',
  // 删除
  delete: 'delete',
  // 重置
  reset: 'reset',
  // 重置
  resetPassword: 'resetPassword',
  // 重置
  resetPasswordByAdmin: 'resetPasswordByAdmin',
  // 重置
  resetPasswordBySelf: 'resetPasswordBySelf',
  topicRepeat(){
    
  }
}